//Models
PJQ.models.emailTemplates = {};
PJQ.models.emailTemplates.EmailTemplate = PJQ.models.BaseModel.extend({
    idAttribute: 'emailTemplateId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'emailTemplates',
                value: this.id
            }
        ])
    }
});

//Collections
PJQ.collections.emailTemplates = {};
PJQ.collections.emailTemplates.EmailTemplates = PJQ.collections.BaseCollection.extend({
    options: {
        projectMessage: false
    },
    model: PJQ.models.emailTemplates.EmailTemplate,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'emailTemplates'
            }
        ], [
            {
                parameter: 'projectMessage',
                value: this.options.projectMessage
            },
        ])
    }
});
